<template>
  <div>
    <div class="card card-video collage-video-item h-100" @click="$emit('select-video', video)">
      <div class="card-img-caption h-100">
        <div class="img-gradient h-100">
          <img class="card-img-top img-video" :src="video.image_url">
        </div>
      </div>
      <img class="icon-play position-absolute" src="@/assets/icon-play.svg" height="50">
    </div>
    <div class="video-gallery-item-metadata d-flex justify-content-between mt-2">
      <span class="text-white" v-if="video.duration">{{ video.duration | formatSecondsToHHMMSS }}</span>
    </div>
  </div>
</template>

<script>
import {observeMedia} from "@/utils/media";

export default {
  name: "CollageVideoItem",
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.observeMedia(this.$el, '.collage-video-item', this.video.id, true)
  },
  methods: {
    observeMedia,
  }
}
</script>

<style scoped>

</style>